class JvanEditorialDrawer extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    this.closeButton = this.querySelector('[data-editorial-drawer-close]');
    this.backdrop = this.querySelector('[data-editorial-drawer-backdrop]');
    if (!this.details || !this.closeButton || !this.backdrop) return;

    this.onToggle = this.onToggle.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.close = this.close.bind(this);

    this.details.addEventListener('toggle', this.onToggle);
    this.closeButton.addEventListener('click', this.close);
    this.backdrop.addEventListener('click', this.close);
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    if (!this.details) return;
    this.details.removeEventListener('toggle', this.onToggle);
    this.closeButton?.removeEventListener('click', this.close);
    this.backdrop?.removeEventListener('click', this.close);
    document.removeEventListener('keydown', this.onKeydown);
    document.documentElement.classList.remove('jvan-editorial-drawer-open');
  }

  onToggle() {
    document.documentElement.classList.toggle('jvan-editorial-drawer-open', this.details.open);
    if (this.details.open) requestAnimationFrame(() => this.closeButton.focus());
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.details.open) this.close();
  }

  close() {
    this.details.open = false;
    document.documentElement.classList.remove('jvan-editorial-drawer-open');
    this.details.querySelector('summary')?.focus();
  }
}

if (!customElements.get('jvan-editorial-drawer')) {
  customElements.define('jvan-editorial-drawer', JvanEditorialDrawer);
}
